// transformNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const TransformNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-input`,
      style: { left: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-output`,
      style: { right: '-2px' }
    }
  ];

  const fields = [
    {
      name: 'transformType',
      label: 'Transform',
      type: 'select',
      defaultValue: data?.transformType || 'uppercase',
      options: [
        { value: 'uppercase', label: 'Uppercase' },
        { value: 'lowercase', label: 'Lowercase' },
        { value: 'reverse', label: 'Reverse' },
        { value: 'trim', label: 'Trim' },
        { value: 'length', label: 'Length' },
        { value: 'custom', label: 'Custom' }
      ]
    },
    {
      name: 'customFunction',
      label: 'Custom Function',
      type: 'textarea',
      defaultValue: data?.customFunction || 'return x + "_transformed"',
      rows: 2,
      style: { fontFamily: 'monospace', fontSize: '11px' }
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="transform"
      title="Transform"
      handles={handles}
      fields={fields}
      className="max-w-[350px]"
    />
  );
};
